import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { notBlank } from "../common/general";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { getOptInTermsDialog } from "common/selectors";
import { ACCEPT_OPT_IN, DECLINE_OPT_IN } from "terms/termsActions";
import { useDispatch, useSelector } from "react-redux";
import grey from "@material-ui/core/colors/grey";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  iframeContainer: {
    padding: theme.spacing(1),
    height: "100%",
    minHeight: 500,
    borderBottomStyle: "solid",
    borderBottomColor: grey[300],
  },

  iframe: {
    width: "100%",
    height: "100%",
    minHeight: 500,
  },

  paper: {
    width: "90%",
    height: "95%",
  },

  actionsContainer: {
    padding: theme.spacing(2),
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },

  cancelButton: {
    textTransform: "uppercase",
  },
}));

const OptInTermsDialog = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { optInId, optInName, acceptTitle, termsUri, visible } =
    useSelector(getOptInTermsDialog);

  const dispatch = useDispatch();
  const onAccept = (id) => dispatch({ type: ACCEPT_OPT_IN, id });
  const onDecline = (id) => dispatch({ type: DECLINE_OPT_IN, id });

  return (
    <Dialog
      onClose={onDecline}
      open={visible}
      aria-labelledby="terms-dialog-title"
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogTitle id="terms-dialog-title">{optInName}</DialogTitle>
      <DialogContent>
        <div className={classes.iframeContainer}>
          <iframe
            title={t("optin_terms_title")}
            src={termsUri}
            className={classes.iframe}
            frameBorder={0}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <div className={classes.actionsContainer}>
          <Button
            classes={{ label: classes.cancelButton }}
            onClick={() => onDecline(optInId)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => onAccept(optInId)}
          >
            {notBlank(acceptTitle) ? acceptTitle : t("optin_terms_accept")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default OptInTermsDialog;
